import SearchableSelect from '../Form/SearchableSelect';

const MARKS_TYPE_OPTIONS = [
  { value: 'Percentage', label: 'Percentage (%)' },
  { value: 'CGPA', label: 'CGPA (0-10)' },
];

const MarksSlider = ({ label, value, field, dispatch, marksType, marksTypeField }) => {
  const isCGPA = marksType === 'CGPA';
  const maxValue = isCGPA ? 10 : 100;
  // Keep decimal precision for both CGPA and Percentage.
  const displayValue = value ? parseFloat(value).toFixed(1) : '0.0';
  const displayUnit = isCGPA ? 'CGPA' : '%';
  
  return (
    <div className="mb-4 p-3 rounded-lg" style={{ 
      backgroundColor: 'var(--color-surface)', 
      border: '1px solid var(--color-border)' 
    }}>
      <div className="flex items-center justify-between mb-2">
        <label className="block font-medium" style={{ color: 'var(--color-text)' }}>
          {label}: <span className="font-bold" style={{ color: 'var(--color-primary)' }}>{displayValue} {displayUnit}</span>
        </label>
        <div className="flex items-center gap-2">
          <span className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
            Type:
          </span>
          <SearchableSelect
            value={marksType || 'Percentage'}
            onChange={(e) => {
              if (marksTypeField) {
                const newMarksType = e.target.value;
                dispatch({ type: 'UPDATE_FIELD', field: marksTypeField, value: newMarksType });

                const currentValue = parseFloat(value) || 0;
                if (currentValue > 0) {
                  if (isCGPA && newMarksType === 'Percentage') {
                    const convertedValue = currentValue * 10;
                    dispatch({ type: 'UPDATE_FIELD', field, value: Math.min(100, convertedValue).toFixed(0) });
                  } else if (!isCGPA && newMarksType === 'CGPA') {
                    const convertedValue = currentValue / 10;
                    dispatch({ type: 'UPDATE_FIELD', field, value: Math.min(10, convertedValue).toFixed(1) });
                  }
                }
              }
            }}
            className="marks-type-select"
            placeholder="Type"
            options={MARKS_TYPE_OPTIONS}
            required
          />
        </div>
      </div>
      <input
        type="range"
        min="0"
        max={maxValue}
        step={0.1}
        value={value || 0}
        onChange={(e) => {
          const newValue = e.target.value;
          const formattedValue = parseFloat(newValue).toFixed(1);
          dispatch({ type: 'UPDATE_FIELD', field, value: formattedValue });
        }}
        className="w-full"
        style={{ cursor: 'pointer' }}
      />
      <div className="flex justify-between text-xs mt-1" style={{ color: 'var(--color-text-secondary)' }}>
        <span>0 {displayUnit}</span>
        <span className="font-semibold">{maxValue} {displayUnit}</span>
      </div>
      {isCGPA && (
        <div className="text-xs mt-1 italic" style={{ color: 'var(--color-text-secondary)' }}>
          💡 CGPA scale: 0-10 (e.g., 8.5 CGPA)
        </div>
      )}
    </div>
  );
};

export default MarksSlider;

